import { Predicate } from "@siteimprove/alfa-predicate";
import {} from "../../attribute.js";
import {} from "../../node.js";
const { property } = Predicate;
export function hasAttribute(nameOrPredicate, value = () => true) {
    if (typeof nameOrPredicate === "function") {
        return (node) => node.attribute(nameOrPredicate).isSome();
    }
    const name = nameOrPredicate;
    const predicate = property("value", value);
    return (node) => node.attribute(name).some(predicate);
}
//# sourceMappingURL=has-attribute.js.map